var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 166,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1732 48.0228C85.6049 47.6847 91.5931 51.1956 95.0639 52.4305C99.6687 54.0671 111.213 56.4437 113.515 60.4372C115.312 63.5537 115.092 77.448 114.813 81.5984C113.801 96.7054 102.467 109.122 89.5889 115.845C82.8723 119.351 81.0954 118.29 74.8138 114.738C54.7886 103.414 49.47 88.6717 51.3545 66.092C52.2515 55.346 60.4811 56.1913 68.6398 53.2463C72.2107 51.9576 78.898 48.3487 82.1732 48.0253V48.0228ZM85.512 69.1447C86.585 62.4536 79.4944 62.5908 80.6359 69.1447C77.9424 69.5147 69.5417 67.5644 71.0522 72.4229C71.7952 74.8093 74.4545 73.7092 74.54 74.2678L74.5327 88.7158C72.2645 88.5565 70.2529 89.4287 71.0522 91.9988C71.9688 94.9413 78.0963 93.1185 80.6359 93.6085C79.5604 100.295 86.651 100.17 85.512 93.6085C92.3826 94.3729 96.2591 91.7661 95.2399 84.4698C95.0981 83.4604 94.2109 82.13 94.2109 81.5788C94.2109 81.0275 95.1421 79.5109 95.2765 78.3177C96.1027 71.0166 92.5439 68.3313 85.512 69.1423V69.1447Z",
    fill: "#94B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4113 78.9303V74.0375H89.3763C90.7646 74.0375 90.7646 78.9303 89.3763 78.9303H79.4113Z",
    fill: "#94B5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4113 88.7158V83.823H89.3763C90.7646 83.823 90.7646 88.7158 89.3763 88.7158H79.4113Z",
    fill: "#94B5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.687edda8226e4ef607bce6b4d01db90f.svg";
export { ForwardRef as ReactComponent };